import axiosInstance from 'shared/services/api/axiosInstance';

const base = (distinctId) => `/agent-runs/users/${encodeURIComponent(distinctId)}/profile`;

function windowParams({ teamId, from, to }) {
  const params = { team_id: teamId };
  if (from) params.time_start = from;
  if (to) params.time_end = to;
  return params;
}

// An identical ask while one is still in flight shares it: StrictMode mounts
// the drawer twice in development, which otherwise sent the profile twice.
const inFlight = new Map();
function shared(key, fetch) {
  if (inFlight.has(key)) return inFlight.get(key);
  const p = fetch().finally(() => inFlight.delete(key));
  inFlight.set(key, p);
  return p;
}

/** One end user's agent profile for a period: totals, agents, evals, feedback summary, properties. No lists. */
export function getUserProfile({ teamId, distinctId, from, to }) {
  return shared(`profile|${teamId}|${distinctId}|${from}|${to}`, async () => {
    const { data } = await axiosInstance.get(base(distinctId), { params: { ...windowParams({ teamId, from, to }), lists: 0 } });
    return data;
  });
}

/** One tab's rows, 50 at a time: kind is 'runs' | 'conversations' | 'feedback'. Returns { rows, has_more }. */
export function getUserProfileList(kind, { teamId, distinctId, from, to, offset = 0 }) {
  return shared(`${kind}|${teamId}|${distinctId}|${from}|${to}|${offset}`, async () => {
    const { data } = await axiosInstance.get(`${base(distinctId)}/${kind}`, { params: { ...windowParams({ teamId, from, to }), offset } });
    return data;
  });
}
